import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "my-pages-rentals" }
const _hoisted_2 = { class: "my-pages-rentals__header" }
const _hoisted_3 = { class: "my-pages-rentals__header-title" }
const _hoisted_4 = { class: "my-pages-rentals__header-sub-title" }
const _hoisted_5 = { class: "my-pages-rentals__list" }
const _hoisted_6 = { class: "my-pages-rentals__item-info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "my-pages-rentals__item-image-overlay" }, null, -1)
const _hoisted_8 = { class: "my-pages-rentals__item-details" }
const _hoisted_9 = { class: "my-pages-rentals__item-brand" }
const _hoisted_10 = { class: "my-pages-rentals__item-product-name" }

import { ref, onMounted, computed } from 'vue';
import useContext from '@/composables/useContext';

import useRentals from '@/composables/useRentals';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useLitium from '@/composables/useLitium';
import ImageWithFallback from '@/components/ImageWithFallback.vue';

import MyPagesBack from './components/MyPagesBack.vue';
import Checkbox from '../forms/Checkbox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPagesRentals',
  emits: ['close-modal', 'back'],
  setup(__props, { emit }) {

const { mitt } = useContext();

const { websiteText } = useWebsiteTexts();
const { fetchMyRentals, stopRentingProduct } = useRentals();
const { toLitiumMediaUrl } = useLitium();

const rentals = ref([]);
const isMounted = ref(false);
const transactionError = ref('');



const subTitle = computed(
  () =>
    websiteText(
      'my_pages__rentals_products',
      { products: rentals.value.length }
    ).value
);

const getProductImageUrl = (row) =>
  toLitiumMediaUrl?.(row.imageId, { maxHeight: 300 }) || '';

const onStopRentingProductClick = async (row) => {
  transactionError.value = '';

  const { error } = await stopRentingProduct(row.articleNumber);
  if (error !== 'NONE') {
    row.isRented = true;
    transactionError.value =
      websiteText('rent__stop_renting_product_error').value ||
      'rent__stop_renting_product_error';
  } else {
    rentals.value = rentals.value.filter(
      (f: any) => f.articleNumber !== row.articleNumber
    );
    mitt.emit('rentalStateChange', {
      articleNumber: row.articleNumber,
      state: false,
    });
  }
};

onMounted(async () => {
  isMounted.value = true;
  rentals.value = await fetchMyRentals();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MyPagesBack, {
      onBack: _cache[0] || (_cache[0] = ($event: any) => (emit('back'))),
      onExit: _cache[1] || (_cache[1] = ($event: any) => (emit('close-modal')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(websiteText)('my_pages__rentals').value), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(subTitle)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rentals.value, (rental, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "my-pages-rentals__list-item",
          key: `${rental.articleNumber}${idx}`
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: rental.url,
              class: "my-pages-rentals__item-image-container"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                (isMounted.value)
                  ? (_openBlock(), _createBlock(ImageWithFallback, {
                      key: 0,
                      class: "my-pages-rentals__item-image",
                      alt: rental.name,
                      image: getProductImageUrl(rental),
                      loading: "lazy"
                    }, null, 8, ["alt", "image"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(rental.brand), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(rental.name), 1)
              ]),
              _createVNode(Checkbox, {
                class: "my-pages-rentals__item-rent-checkbox",
                modelValue: rental.isRented,
                "onUpdate:modelValue": ($event: any) => ((rental.isRented) = $event),
                text: 
                _unref(websiteText)('rent__renting_product').value || 'rent__renting_product'
              ,
                onInput: ($event: any) => (onStopRentingProductClick(rental))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "text", "onInput"]),
              _withDirectives(_createElementVNode("div", { class: "my-pages-rentals__rent-error" }, _toDisplayString(transactionError.value), 513), [
                [_vShow, transactionError.value]
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})